import * as $ from "jquery"
import * as Cookies from "js-cookie";

import { App } from "../../_app";
import { Resources } from "../resources";
import { AjaxServiceResponse } from "../service-response";
import { DynaTrace } from "../../dynatrace";

declare const dtrum: DynaTrace;

interface IGetLoginStatus {
    RedirectUrl: string;
}

//App.Common.Dialogs
export class Dialogs {
    static openDialogDataLostOnLangChange(button: HTMLAnchorElement) {
        const text = $("#datalostonlangchange");
        BootstrapDialog.show({
            id: "modalDataLostOnLangChange",
            title: $("<h2>" + $(text).data("dialogheadline") + "</h2>"),
            message: $("<p class=\"alert-dialog\">" + $(text).data("dialogtext") + "</p>"),
            buttons: [
                {
                    label: $(text).data("dialogno"),
                    cssClass: "btn-secondary",
                    action: function (dialogItself) {
                        dialogItself.close();
                    }
                },
                {
                    label: $(text).data("dialogyes"),
                    cssClass: "btn-primary",
                    action: function (dialogItself) {
                        App.displayWarningOnUnload = false;
                        window.location.href = button.href;
                        if ($(button).data("langcode") !== null) {
                            App.saveLangInSession(button);
                        }
                        dialogItself.close();
                    }
                }
            ]
        });
    }

    static openCookieModal() {
        const button = document.getElementById("cookiemodal");
        App.Common.Logging.logBrowserInfos();
        const daysToExpire = Number(button.getAttribute("data-expires"));
        BootstrapDialog.show({
            id: "modalCookieInfo",
            title: "<h2>" + button.getAttribute("data-dialogheadline") + "</h2>",
            message: "<div>" + button.getAttribute("data-dialogtext") + "</div>",
            onshown: function (dialog) {
                const link = $.parseHTML(button.getAttribute("data-dialoglink"));
                dialog.getModalFooter().first().append(link);
                dialog.getModalFooter().find("#privacypolicy").addClass("cookiebtn-alignleft");
                dialog.getModalFooter().find("#privacypolicy").addClass("btn");
            },
            buttons: [
                {
                    label: button.getAttribute("data-dialogyes"),
                    cssClass: "btn-primary btn-fullwidth marginBottom",
                    action: (dialogItself) => {
                        Cookies.set("NonEssentialCookiesAccepted", "yes", { expires: daysToExpire, secure: true, sameSite: "lax" });
                        dialogItself.close();
                        // enable dynatrace
                        if (typeof (dtrum) !== "undefined") {
                            dtrum.enable();
                        }
                    }
                },
                {
                    label: button.getAttribute("data-dialogno"),
                    cssClass: "btn-secondary btn-fullwidth",
                    action: (dialogItself) => {
                        Cookies.set("NonEssentialCookiesAccepted", "no", { expires: daysToExpire, secure: true, sameSite: "lax" });
                        // No Analytics and no dynatrace 
                        dialogItself.close();
                        // disable dynatrace
                        if (typeof (dtrum) !== "undefined") {
                            dtrum.disable();
                        }
                    }
                }
            ]
        });
    }

    static showDataLossWarning() {
        return document.getElementById("ordersummaryview") == null && document.getElementById("seamlesspaymentview") == null;
    }

    static warningLooseOfData(link: HTMLAnchorElement, forceWarning: boolean) {
        forceWarning = forceWarning || false;
        if (forceWarning
            && Dialogs.showDataLossWarning()) {
            App.Common.Dialogs.openDialogDataLostOnLangChange(link);
        } else {
            if ($("form:visible:not(#unitchoice-form)").length > 0) {
                let filledInputs = 0;
                $("form input[type=\"text\"], form input[type=\"email\"], form input[type=\"passwort\"], form select, form input.hiddenuserinput[type=\"hidden\"], form #filesuploaded")
                    .each(function () {
                        if (App.Common.Functions.hasValue(this)) {
                            if (!$(this).parent().hasClass("unit-change-container")) {
                                filledInputs++;
                            }
                        }
                    });
                if (document.getElementById("progress-navigation") != null) {
                    if (App.inputChanged
                        && App.Common.Dialogs.showDataLossWarning()) {
                        App.Common.Dialogs.openDialogDataLostOnLangChange(link);
                    } else {
                        App.displayWarningOnUnload = false;
                        window.location.href = link.href;
                        return true;
                    }
                } else {
                    if (filledInputs > 0) {
                        App.Common.Dialogs.openDialogDataLostOnLangChange(link);
                    } else {
                        App.displayWarningOnUnload = false;
                        window.location.href = link.href;
                        return true;
                    }
                }
            } else {
                window.location.href = link.href;
                return true;
            }
        }
    }

    static openModalSessionAboutToExpire(button: HTMLElement) {
        BootstrapDialog.show({
            id: "modalSessionAboutToExpire",
            title: $("<h2>" + $(button).data("dialogheadline") + "</h2>"),
            message: $("<p class=\"alert-dialog\">" + $(button).data("dialogtext") + "</p>"),
            buttons: [
                {
                    label: $(button).data("dialogyes"),
                    cssClass: "btn-primary",
                    id: "cancel-btn",
                    action: (dialogItself) => {
                        App.Common.Functions.buttonLoader("cancel-btn", true);

                        let data = {};
                        if (App.isCiamSet) {
                            // Only for Webshop, not SPP
                            data = {
                                isCiam: App.isCiam,
                                isAnonymous: App.isAnonymous,
                                allowAspNetSessionIsAboutToExpireDialog: App.allowAspNetSessionIsAboutToExpireDialog
                            };
                        }
                        $.ajax({
                            url: Resources.Apis.getLoginStatusURL,
                            type: "GET",
                            data: data,
                            success: function (response: AjaxServiceResponse<IGetLoginStatus>) {
                                if (response.Status === App.Common.Constants.Api.ResponseMessage.Success) {
                                    if (response.Data.RedirectUrl == null) {
                                        dialogItself.close();
                                    } else {
                                        App.displayWarningOnUnload = false; //prevent "do you want to leave"-message
                                        window.location.href = response.Data.RedirectUrl;
                                    }
                                }
                            },
                            error: (error) => {
                                const errorString = JSON.stringify(error);
                                App.Common.Logging.logWarning(`${Resources.Apis.getLoginStatusURL} - Error: "${errorString}"`);
                                dialogItself.close();
                            }
                        });
                    }
                }
            ]
        });
    }
}